import React, { useEffect, useRef, useState } from 'react';
import parse from 'html-react-parser';
import { Modal } from 'react-bootstrap';

import moment from 'moment-timezone';

import { Configuration } from '../../classess/configuration/configuration';
import {
    badgetStatusGeneric, getProcessButtons, setDateTimeFormatGlobalString, isUndNullEmp, isValidDate, getLanguageObj, getResponse,
    handleResponseMessageAsync, settings, styles,
} from '../../helpers/main';
import { ConfigurationService } from '../../services/configurations/ConfigurationService';
import { GlobalFormats } from '../../classess/main/globalFormats';
import { userAuthContextType } from '../../auth/AuthProvider';

const { icons, images, labels, messages, } = settings;

const currentMethod = 'ConfigurationAddEditDetails';

export default function ConfigurationAddEditDetails({
    modalObj = {
        $: {},
        type: 0,
        auth: userAuthContextType,
        showModal: false,
        languageObj: GlobalFormats?.getClass(getLanguageObj({ subMethod: currentMethod })?.result),
        dtConfigurationsId: '',
        dtConfigurationsRowId: 0,
    },
    setModalObj = {},
    configuration = Configuration.getClass({}, false),
    setConfiguration = {},
    setConfigurations = [],
}) {
    //#region variables
    const isMount = useRef(false);
    const [process, setProcess] = useState({
        // showLoading: false,
        save: false,
    });
    const [errors, setErrors] = useState({
        name: '',
        paginated: '',
        fromDateTime: '',
        toDateTime: '',
        success: '',
        warning: '',
        danger: '',
    });

    const [dataFormLength] = useState(Configuration.minMaxLength(false));
    const controls = {
        buttons: {
            back: {
                defaultClass: 'btn btn-outline-secondary shadow-sm font-weight-bold mx-1 px-4',
                id: 'btnModalBack',
            },
            save: {
                defaultClass: 'btn btn-primary shadow-sm font-weight-bold mx-1 px-4',
                id: 'btnModalSave',
            },
            closeModal: {
                defaultClass: 'close border-0 bg-transparent',
                id: 'btnModalClose',
            },
        },
        icons: {
            save: {
                id: 'iconModalSave',
                defaultClass: icons?.fasFa?.save,
            },
            back: {
                id: 'iconModalBack',
                defaultClass: icons?.fasFa?.arrowCircleLeft,
            },
        },
        inputs: {
            name: {
                id: 'inputModalName',
            },
            paginated: {
                id: 'inputModalPaginated',
            },
            fromDateTime: {
                id: 'inputModalFromDateTime',
            },
            toDateTime: {
                id: 'inputModalToDateTime',
            },
            success: {
                id: 'inputModalSuccess',
            },
            warning: {
                id: 'inputModalWarning',
            },
            danger: {
                id: 'inputModalDanger',
            },
        },
        spiners: {
            save: {
                id: 'spModalSave',
                defaultClass: '',
            }
        },
        pickers: {
            fromDateTime: {
                id: 'pkModalFromDateTime',
            },
            toDateTime: {
                id: 'pkModalToDateTime',
            },
        },
        checkBox: {
            isValid: {
                id: 'chkModalIsValid',
            },
        }
    };
    //#endregion variables

    //#region methods
    const addConfiguration = async ({
        e = undefined,
        subMethod = '',
    } = {}) => {
        const currentMethod = 'addConfiguration';
        let response = getResponse({ type: 0 });
        try {
            e?.preventDefault?.();

            //#region errors default / validate data
            response = setErrorsDefault({ subMethod: currentMethod, });
            if (!response?.isSuccess || response?.isWarning) return;

            response = setData({ subMethod: currentMethod });
            if (!response?.isSuccess || response?.isWarning) return;

            response = validateFormData({ subMethod: currentMethod });
            if (!response?.isSuccess || response?.isWarning) return;
            //#endregion errors default / validate data

            setProcess(prev => ({ ...prev, save: true, }));

            //#region configuration (create)
            response = await ConfigurationService.create({
                auth: modalObj?.auth,
                data: configuration,
                languageId: modalObj?.languageObj?.id,
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) return;

            const configurationResult = Configuration.getClass(
                response?.result?.configuration || response?.result || {},
                false
            );
            //#endregion configuration (create)

            //#region datatable (add row)
            const processButtons = [];
            modalObj.$(`#${modalObj.dtConfigurationsId}`).DataTable().row.add([
                configurationResult.name,
                badgetStatusGeneric({
                    type: configurationResult.isValid ? 0 : 5,
                    value: configurationResult.isValid ? labels?.yes?.[modalObj?.languageObj?.id] : labels?.no?.[modalObj?.languageObj?.id]
                }),
                configurationResult.paginated,
                getProcessButtons({
                    id: configurationResult.id,
                    description: configurationResult.name,
                    showDetails: false,
                    labelDetails: labels?.details[modalObj?.languageObj?.id],
                    enabledDetails: false,
                    showDelete: true,
                    labelDelete: labels?.delete[modalObj?.languageObj?.id],
                    enabledDelete: true,
                    showEdit: true,
                    labelEdit: labels?.edit?.[modalObj?.languageObj?.id],
                    enabledEdit: true,
                    processButtons: processButtons,
                })?.result,
            ])?.draw(true);
            //#endregion datatable (add row)

            setConfigurations([configurationResult]);

            response.msgText = `${messages?.processCompletedSuccessfully?.[modalObj?.languageObj?.id]}.`;
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        } finally {
            if (!isMount?.current) return;

            setProcess(prev => ({ ...prev, save: false, }));

            if (response?.isSuccess && !response?.isWarning) {
                setDefaultValue({ closeModal: true, subMethod: currentMethod });
            }

            if (!response?.isSuccess || response?.isWarning || response?.msgText !== '' || response?.msgTextHtml !== '') {
                await handleResponseMessageAsync({
                    response,
                    currentMethod,
                    auth: modalObj?.auth,
                    languageId: modalObj?.languageObj?.id
                });
            }
        }
    }

    const editConfiguration = async ({
        e = undefined,
        subMethod = '',
    } = {}) => {
        const currentMethod = 'editConfiguration';
        let response = getResponse({ type: 0 });
        try {
            e?.preventDefault?.();

            //#region errors default / validate data
            response = setErrorsDefault({ subMethod: currentMethod });
            if (!response?.isSuccess || response?.isWarning) return;

            response = setData({ subMethod: currentMethod });
            if (!response?.isSuccess || response?.isWarning) return;

            response = validateFormData({ subMethod: currentMethod });
            if (!response?.isSuccess || response?.isWarning) return;
            //#endregion errors default / validate data

            setProcess(prev => ({ ...prev, save: true, }));

            //#region configuration (update)
            response = await ConfigurationService.update({
                auth: modalObj?.auth,
                id: configuration.id,
                data: configuration,
                languageId: modalObj?.languageObj?.id,
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) return;

            const configurationResult = Configuration.getClass(
                response?.result?.configuration || response?.result || {},
                false
            );
            //#endregion configuration (update)

            //#region datatable (update row)
            const processButtons = [];
            modalObj.$(`#${modalObj.dtConfigurationsId}`).DataTable().row(modalObj.dtConfigurationsRowId).data([
                configurationResult.name,
                badgetStatusGeneric({
                    type: configurationResult.isValid ? 0 : 5,
                    value: configurationResult.isValid ? labels?.yes?.[modalObj?.languageObj?.id] : labels?.no?.[modalObj?.languageObj?.id]
                }),
                configurationResult.paginated,
                getProcessButtons({
                    id: configurationResult.id,
                    description: configurationResult.name,
                    showDetails: false,
                    labelDetails: labels?.details[modalObj?.languageObj?.id],
                    enabledDetails: false,
                    showDelete: true,
                    labelDelete: labels?.delete[modalObj?.languageObj?.id],
                    enabledDelete: true,
                    showEdit: true,
                    labelEdit: labels?.edit?.[modalObj?.languageObj?.id],
                    enabledEdit: true,
                    processButtons: processButtons,
                })?.result,
            ])?.draw(true);
            //#endregion datatable (update row)

            setConfigurations([configurationResult]);

            response.msgText = `${messages?.processCompletedSuccessfully?.[modalObj?.languageObj?.id]}.`;
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        } finally {
            if (!isMount?.current) return;
            setProcess(prev => ({ ...prev, save: false, }));

            if (response?.isSuccess && !response?.isWarning) {
                setDefaultValue({ closeModal: true, subMethod: currentMethod });
            }

            if (!response?.isSuccess || response?.isWarning || response?.msgText !== '' || response?.msgTextHtml !== '') {
                await handleResponseMessageAsync({
                    response,
                    currentMethod,
                    auth: modalObj?.auth,
                    languageId: modalObj?.languageObj?.id
                });
            }
        }
    }

    //#region others
    const getData = async ({
        subMethod = '',
    } = {}) => {
        const currentMethod = 'getData';
        let response = getResponse({ type: 0 });
        try {
            if (!isUndNullEmp({ data: modalObj?.auth?.user, subMethod: currentMethod })?.result) {
                // setProcess(prev => ({ ...prev, showLoading: true, }));

                //#region date in control
                response = setDateInControl({
                    _date: new Date(),
                    _fromDateTime: configuration?.fromDateTime,
                    _toDateTime: configuration?.toDateTime,
                    subMethod: currentMethod,
                });

                if (!response?.isSuccess || response?.isWarning) return;
                //#endregion date in control

                //#region is available
                modalObj?.$(`#${controls?.checkBox?.isValid.id}`).attr('checked', configuration?.isValid);
                //#endregion is available
            }
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        } finally {
            if (!isMount?.current) return;
            // setProcess(prev => ({ ...prev, showLoading: false }));
            if (!response?.isSuccess || response?.isWarning || response?.msgText !== '' || response?.msgTextHtml !== '') {
                await handleResponseMessageAsync({
                    response,
                    currentMethod,
                    auth: modalObj?.auth,
                    languageId: modalObj?.languageObj?.id
                });
            }
        }
    }

    const setDateInControl = ({
        _date = undefined,
        _fromDateTime = undefined,
        _toDateTime = undefined,
        subMethod = '',
    } = {}) => {
        let response = getResponse({ type: 0 });
        const currentMethod = 'setDateInControl';
        try {
            //#region variables
            let fromDateTime = '';
            let toDateTime = '';
            const tf = modalObj?.languageObj?.format?.time?.type;
            const dtf = `${modalObj?.languageObj?.format?.date?.f11} ${modalObj?.languageObj?.format?.time?.picker?.hhmm}`;
            const df = modalObj?.languageObj?.format?.date?.f1;
            //#endregion variables

            //#region methods
            if (!isUndNullEmp({ data: _fromDateTime, subMethod: currentMethod })?.result) {
                fromDateTime = setDateTimeFormatGlobalString({ date: _fromDateTime, dateFormat: df, timeFormat: tf, withSeconds: false, subMethod: currentMethod, })?.result;
            } else if (!isUndNullEmp({ data: _date, subMethod: currentMethod })?.result) {
                fromDateTime = setDateTimeFormatGlobalString({ date: _date, dateFormat: df, timeFormat: tf, withSeconds: false, subMethod: currentMethod, })?.result;
            }

            if (!isUndNullEmp({ data: _toDateTime, subMethod: currentMethod })?.result) {
                toDateTime = setDateTimeFormatGlobalString({ date: _toDateTime, dateFormat: df, timeFormat: tf, withSeconds: false, subMethod: currentMethod, })?.result;
            } else if (!isUndNullEmp({ data: _date, subMethod: currentMethod })?.result) {
                toDateTime = setDateTimeFormatGlobalString({ date: _date, dateFormat: df, timeFormat: tf, withSeconds: false, subMethod: currentMethod, })?.result;
            }

            modalObj.$.fn.datetimepicker.Constructor.Default = modalObj.$.extend({}, modalObj.$.fn.datetimepicker.Constructor.Default, {
                icons: settings?.react?.tempusDominus?.icons,
                buttons: settings?.react?.tempusDominus?.buttons,
                tooltips: settings?.react?.tempusDominus?.tooltips({ languageId: modalObj?.languageObj?.id }),
                locale: modalObj?.languageObj?.id,
            });

            modalObj.$(`#${controls.pickers.fromDateTime.id}`)?.datetimepicker(
                'options',
                {
                    date: fromDateTime,
                    default: false,
                    timepicker: true,
                    format: dtf,
                }
            );

            modalObj.$(`#${controls.pickers.toDateTime.id}`)?.datetimepicker(
                'options',
                {
                    date: toDateTime,
                    default: false,
                    timepicker: true,
                    format: dtf,
                }
            );
            //#endregion methods
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        }
        return response;
    }

    const setDefaultValue = ({
        closeModal = false,
        subMethod = '',
    } = {}) => {
        const currentMethod = 'setDefaultValue';
        let response = getResponse({ type: 0 });
        try {
            if (closeModal) {
                setModalObj(prev => ({
                    ...prev,
                    showModal: false,
                    type: 0,
                }));
            }
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
            console.log(response?.msgText);
        }
    }

    const validateFormData = ({
        subMethod = '',
    } = {}) => {
        let response = getResponse({ type: 0 });
        const currentMethod = 'validateFormData';
        try {
            //#region variables
            const fromDateTime = modalObj?.$(`#${controls?.inputs?.fromDateTime.id}`).val();
            const toDateTime = modalObj?.$(`#${controls?.inputs?.toDateTime.id}`).val();
            //#endregion variables

            //#region methods
            if (isUndNullEmp({ data: configuration?.name, subMethod: currentMethod })?.result) {
                setErrors(prev => ({ ...prev, name: `${messages?.thisFieldRequired?.[modalObj?.languageObj?.id]}.` }));
                response.isWarning = true;
            }

            if (!isUndNullEmp({ data: configuration?.paginated, subMethod: currentMethod })?.result && configuration.paginated < 0) {
                setErrors(prev => ({ ...prev, paginated: `${messages?.thisFieldRequired?.[modalObj?.languageObj?.id]}.` }));
                response.isWarning = true;
            }

            if (isUndNullEmp({ data: fromDateTime, subMethod: currentMethod })?.result) {
                setErrors(prev => ({ ...prev, fromDateTime: `${messages?.thisFieldRequired?.[modalObj?.languageObj?.id]}.` }));
                response.isWarning = true;
            } else if (!isUndNullEmp({ data: fromDateTime, subMethod: currentMethod })?.result && !isValidDate({ data: fromDateTime, subMethod: currentMethod })?.result) {
                setErrors(prev => ({ ...prev, fromDateTime: `${messages?.youMustEnterValidDateTimeValue[modalObj?.languageObj?.id]}.` }));
                response.isWarning = true;
            }

            if (isUndNullEmp({ data: toDateTime, subMethod: currentMethod })?.result) {
                setErrors(prev => ({ ...prev, toDateTime: `${messages?.thisFieldRequired?.[modalObj?.languageObj?.id]}.` }));
                response.isWarning = true;
            } else if (!isUndNullEmp({ data: toDateTime, subMethod: currentMethod })?.result && !isValidDate({ data: toDateTime, subMethod: currentMethod })?.result) {
                setErrors(prev => ({ ...prev, toDateTime: `${messages?.youMustEnterValidDateTimeValue[modalObj?.languageObj?.id]}.` }));
                response.isWarning = true;
            }

            if (!isUndNullEmp({ data: configuration?.success, subMethod: currentMethod })?.result && configuration.success < 0) {
                setErrors(prev => ({ ...prev, success: `${messages?.thisFieldRequired?.[modalObj?.languageObj?.id]}.` }));
                response.isWarning = true;
            }

            if (!isUndNullEmp({ data: configuration?.warning, subMethod: currentMethod })?.result && configuration.warning < 0) {
                setErrors(prev => ({ ...prev, warning: `${messages?.thisFieldRequired?.[modalObj?.languageObj?.id]}.` }));
                response.isWarning = true;
            }

            if (!isUndNullEmp({ data: configuration?.danger, subMethod: currentMethod })?.result && configuration.danger < 0) {
                setErrors(prev => ({ ...prev, danger: `${messages?.thisFieldRequired?.[modalObj?.languageObj?.id]}.` }));
                response.isWarning = true;
            }
            //#endregion methods
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        }
        return response;
    }

    const setErrorsDefault = ({
        subMethod = '',
    } = {}) => {
        let response = getResponse({ type: 0 });
        const currentMethod = 'setErrorsDefault';
        try {
            setErrors(prev => ({
                ...prev,
                name: '',
                paginated: '',
                fromDateTime: '',
                toDateTime: '',
                success: '',
                warning: '',
                danger: '',
            }));
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        }
        return response;
    }

    const setData = ({
        subMethod = '',
    } = {}) => {
        let response = getResponse({ type: 0 });
        const currentMethod = 'setData';
        try {
            //#region variables
            const fromDateTime = modalObj.$(`#${controls.pickers.fromDateTime.id}`)?.datetimepicker('date')?._d;
            const toDateTime = modalObj.$(`#${controls.pickers.toDateTime.id}`)?.datetimepicker('date')?._d;
            //#endregion variables

            //#region methods
            configuration.fromDateTime = moment(fromDateTime).format(`${modalObj?.languageObj?.format?.date?.f13}T${modalObj?.languageObj?.format?.time?.f2}-04:00`);
            configuration.toDateTime = moment(toDateTime).format(`${modalObj?.languageObj?.format?.date?.f13}T${modalObj?.languageObj?.format?.time?.f2}-04:00`);
            //#endregion methods
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        }
        return response;
    }

    useEffect(() => {
        isMount.current = true;
        getData({ subMethod: 'form - onLoad', });
        return () => {
            isMount.current = false;
        }
    }, []);// eslint-disable-line react-hooks/exhaustive-deps
    //#endregion others
    //#endregion methods
    return (
        <Modal backdrop='static' show={modalObj?.showModal} centered>
            <Modal.Header className='border-bottom-0 pt-4 px-4 bg-white'>
                <Modal.Title className='d-flex align-items-center w-100'>
                    <div className='bg-light p-2 rounded-circle mr-3 shadow-sm'
                        style={{ width: '45px', height: '45px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        <img alt='configurations' src={images?.icons?.settings} style={{ ...styles?.cardHeaderLogo }}></img>
                    </div>
                    <div className='d-flex flex-column'>
                        <span className='h5 mb-0 font-weight-bold text-dark'>{labels?.configuration?.[modalObj?.languageObj?.id]}</span>
                        <div className='d-flex align-items-center mt-1'>
                            <span className={`badge badge-pill py-1 px-2 text-uppercase ${modalObj?.type === 0 ? 'badge-info' : modalObj?.type === 1 ? 'badge-warning text-dark' : 'badge-secondary'}`} style={settings?.html?.badges?.micro}>
                                {modalObj?.type === 0 ? labels?.add?.[modalObj?.languageObj?.id] :
                                    modalObj?.type === 1 ? labels?.edit?.[modalObj?.languageObj?.id] :
                                        labels?.detail?.[modalObj?.languageObj?.id]}
                            </span>
                        </div>
                    </div>
                </Modal.Title>
                <button id={controls?.buttons?.closeModal?.id}
                    type='button'
                    className={controls?.buttons?.closeModal?.defaultClass}
                    data-dismiss='modal'
                    aria-label='Close'
                    disabled={process?.save}
                    style={{ fontSize: '1.5rem', marginTop: '-15px' }}
                    onClick={() => setDefaultValue({ closeModal: true, subMethod: controls?.buttons?.closeModal?.id })}>
                    <span aria-hidden='true'>&times;</span>
                </button>
            </Modal.Header >
            <Modal.Body className='p-0'>
                <form onSubmit={(e) => e.preventDefault()}>
                    <div className='card-body p-4'>
                        {modalObj?.type !== 2 ? (
                            <div>
                                <div className='row'>
                                    <div className='col-12 col-md-6 mb-3'>
                                        <div className='form-group'>
                                            <small className={settings?.html?.labels?.mutedUpperFontWeightBoldDblockMb2}>
                                                <i className={icons?.fasFa?.spellCheck} /> {labels?.name?.[modalObj?.languageObj?.id]}
                                            </small>
                                            <div className='input-group'>
                                                <input id={controls?.inputs?.name?.id}
                                                    className='form-control bg-light border-0 shadow-sm text-dark'
                                                    style={{ borderRadius: '5px' }}
                                                    disabled={process?.save}
                                                    maxLength={dataFormLength?.max?.name}
                                                    onChange={(e) => setConfiguration(prev => ({ ...prev, name: e?.target?.value }))}
                                                    onFocus={() => setErrors(prev => ({ ...prev, name: '' }))}
                                                    value={!isUndNullEmp({ data: configuration, subMethod: controls?.inputs?.name?.id, })?.result && !isUndNullEmp({ data: configuration?.name, subMethod: controls?.inputs?.name?.id, })?.result ?
                                                        configuration.name : ''}
                                                    placeholder={labels?.name?.[modalObj?.languageObj?.id]}
                                                    title={labels?.name?.[modalObj?.languageObj?.id]} />
                                            </div>
                                            <div className='form-text' style={styles?.inputMsgAlert}>{parse(errors?.name)}</div>
                                        </div>
                                    </div>
                                    <div className='col-12 col-md-6 mb-3'>
                                        <div className='form-group'>
                                            <small className={settings?.html?.labels?.mutedUpperFontWeightBoldDblockMb2}>
                                                <i className={icons?.sortNumericUpAlt} /> {labels?.paginated[modalObj?.languageObj?.id]}
                                            </small>
                                            <div className='input-group'>
                                                <input id={controls?.inputs?.paginated.id}
                                                    className='form-control bg-light border-0 shadow-sm text-dark'
                                                    style={{ borderRadius: '5px' }}
                                                    disabled={process?.save}
                                                    maxLength={dataFormLength?.max?.paginated}
                                                    min={0}
                                                    max={100}
                                                    onChange={(e) => setConfiguration(prev => ({ ...prev, paginated: parseInt(e?.target?.value), }))}
                                                    onFocus={() => setErrors(prev => ({ ...prev, paginated: '' }))}
                                                    value={!isUndNullEmp({ data: configuration, subMethod: controls?.inputs?.paginated.id, })?.result && !isUndNullEmp({ data: configuration?.paginated, subMethod: controls?.inputs?.paginated.id, })?.result ?
                                                        configuration?.paginated : 0}
                                                    placeholder={labels?.paginated[modalObj?.languageObj?.id]}
                                                    title={labels?.paginated[modalObj?.languageObj?.id]}
                                                    type='number' />
                                            </div>
                                            <div className='form-text' style={styles?.inputMsgAlert}>{parse(errors?.paginated)}</div>
                                        </div>
                                    </div>
                                </div>

                                <div className='row'>
                                    <div className='col-12 col-md-6 mb-3'>
                                        <div className='form-group'>
                                            <small className={settings?.html?.labels?.mutedUpperFontWeightBoldDblockMb2}>
                                                <i className={icons?.faFa?.calendarAlt} /> {labels?.date?.[modalObj?.languageObj?.id]} ({labels?.from?.[modalObj?.languageObj?.id]})
                                            </small>
                                            {!isUndNullEmp({ data: configuration, subMethod: controls?.inputs?.fromDateTime.id, })?.result &&
                                                !isUndNullEmp({ data: configuration?.fromDateTime, subMethod: controls?.inputs?.fromDateTime.id, })?.result ?
                                                <div id={controls.pickers.fromDateTime.id}
                                                    className='input-group date'
                                                    data-target-input='nearest'>
                                                    <input id={controls?.inputs?.fromDateTime.id}
                                                        className='form-control datetimepicker-input bg-light border-0 shadow-sm text-dark'
                                                        style={{ borderRadius: '5px' }}
                                                        disabled={process?.save}
                                                        data-target={`#${controls.pickers.fromDateTime.id}`}
                                                        data-toggle='datetimepicker'
                                                        onFocus={() => setErrors(prev => ({ ...prev, fromDateTime: '' }))}
                                                        placeholder={labels?.date?.[modalObj?.languageObj?.id]}
                                                        tooltip='tooltip'
                                                        title={labels?.date?.[modalObj?.languageObj?.id]}
                                                        type='text' />
                                                    <div className='input-group-append'
                                                        data-target={`#${controls.pickers.fromDateTime.id}`}
                                                        data-toggle='datetimepicker'>
                                                        <div className='input-group-text bg-secondary border-0'>
                                                            <i className={icons?.faFa?.calendarAlt} />
                                                        </div>
                                                    </div>
                                                </div>
                                                : <div></div>}
                                            <div className='form-text' style={styles?.inputMsgAlert}>{parse(errors?.fromDateTime)}</div>
                                        </div>
                                    </div>
                                    <div className='col-12 col-md-6 mb-3'>
                                        <div className='form-group'>
                                            <small className={settings?.html?.labels?.mutedUpperFontWeightBoldDblockMb2}>
                                                <i className={icons?.faFa?.calendarAlt} /> {labels?.date?.[modalObj?.languageObj?.id]} ({labels?.to?.[modalObj?.languageObj?.id]})
                                            </small>
                                            {!isUndNullEmp({ data: configuration, subMethod: controls?.inputs?.toDateTime.id, })?.result &&
                                                !isUndNullEmp({ data: configuration?.toDateTime, subMethod: controls?.inputs?.toDateTime.id, })?.result ?
                                                <div id={controls.pickers.toDateTime.id}
                                                    className='input-group date'
                                                    data-target-input='nearest'>
                                                    <input id={controls?.inputs?.toDateTime.id}
                                                        className='form-control datetimepicker-input bg-light border-0 shadow-sm text-dark'
                                                        style={{ borderRadius: '5px' }}
                                                        disabled={process?.save}
                                                        data-target={`#${controls.pickers.toDateTime.id}`}
                                                        data-toggle='datetimepicker'
                                                        onFocus={() => setErrors(prev => ({ ...prev, toDateTime: '', }))}
                                                        placeholder={labels?.date?.[modalObj?.languageObj?.id]}
                                                        tooltip='tooltip'
                                                        title={labels?.date?.[modalObj?.languageObj?.id]}
                                                        type='text' />
                                                    <div className='input-group-append'
                                                        data-target={`#${controls.pickers.toDateTime.id}`}
                                                        data-toggle='datetimepicker'>
                                                        <div className='input-group-text bg-secondary border-0'>
                                                            <i className={icons?.faFa?.calendarAlt} />
                                                        </div>
                                                    </div>
                                                </div>
                                                : <div></div>}
                                            <div className='form-text' style={styles?.inputMsgAlert}>{parse(errors?.toDateTime)}</div>
                                        </div>
                                    </div>
                                </div>

                                <div className='row'>
                                    <div className='col-12 col-md-4 mb-3'>
                                        <div className='form-group'>
                                            <small className={settings?.html?.labels?.mutedUpperFontWeightBoldDblockMb2}>
                                                <i className={icons?.fasFa?.checkCircle} /> {labels?.success[modalObj?.languageObj?.id]}
                                            </small>
                                            <div className='input-group'>
                                                <input id={controls?.inputs?.success.id}
                                                    className='form-control bg-light border-0 shadow-sm text-dark'
                                                    style={{ borderRadius: '5px' }}
                                                    disabled={process?.save}
                                                    maxLength={dataFormLength?.max?.success}
                                                    min={0}
                                                    max={999}
                                                    onChange={(e) => setConfiguration(prev => ({ ...prev, success: parseInt(e?.target?.value), }))}
                                                    onFocus={() => setErrors(prev => ({ ...prev, success: '', }))}
                                                    value={!isUndNullEmp({ data: configuration, subMethod: controls?.inputs?.success.id, })?.result && !isUndNullEmp({ data: configuration?.success, subMethod: controls?.inputs?.success.id, })?.result ?
                                                        configuration?.success : 0}
                                                    placeholder={labels?.success[modalObj?.languageObj?.id]}
                                                    title={labels?.success[modalObj?.languageObj?.id]}
                                                    type='number' />
                                            </div>
                                            <div className='form-text' style={styles?.inputMsgAlert}>{parse(errors?.success)}</div>
                                        </div>
                                    </div>
                                    <div className='col-12 col-md-4 mb-3'>
                                        <div className='form-group'>
                                            <small className={settings?.html?.labels?.mutedUpperFontWeightBoldDblockMb2}>
                                                <i className={icons?.fasFa?.exclamationTrinagle} /> {labels?.warning[modalObj?.languageObj?.id]}
                                            </small>
                                            <div className='input-group'>
                                                <input id={controls?.inputs?.warning.id}
                                                    className='form-control bg-light border-0 shadow-sm text-dark'
                                                    style={{ borderRadius: '5px' }}
                                                    disabled={process?.save}
                                                    maxLength={dataFormLength?.max?.warning}
                                                    min={0}
                                                    max={999}
                                                    onChange={(e) => setConfiguration(prev => ({ ...prev, warning: parseInt(e?.target?.value), }))}
                                                    onFocus={() => setErrors(prev => ({ ...prev, warning: '', }))}
                                                    value={!isUndNullEmp({ data: configuration, subMethod: controls?.inputs?.warning.id, })?.result && !isUndNullEmp({ data: configuration?.warning, subMethod: controls?.inputs?.warning.id, })?.result ?
                                                        configuration?.warning : 0}
                                                    placeholder={labels?.warning[modalObj?.languageObj?.id]}
                                                    title={labels?.warning[modalObj?.languageObj?.id]}
                                                    type='number' />
                                            </div>
                                            <div className='form-text' style={styles?.inputMsgAlert}>{parse(errors?.warning)}</div>
                                        </div>
                                    </div>
                                    <div className='col-12 col-md-4 mb-3'>
                                        <div className='form-group'>
                                            <small className={settings?.html?.labels?.mutedUpperFontWeightBoldDblockMb2}>
                                                <i className={icons?.fasFa?.times} /> {labels?.danger[modalObj?.languageObj?.id]}
                                            </small>
                                            <div className='input-group'>
                                                <input id={controls?.inputs?.danger.id}
                                                    className='form-control bg-light border-0 shadow-sm text-dark'
                                                    style={{ borderRadius: '5px' }}
                                                    disabled={process?.save}
                                                    maxLength={dataFormLength?.max?.danger}
                                                    min={0}
                                                    max={999}
                                                    onChange={(e) => setConfiguration(prev => ({ ...prev, danger: parseInt(e?.target?.value), }))}
                                                    onFocus={() => setErrors(prev => ({ ...prev, danger: '', }))}
                                                    value={!isUndNullEmp({ data: configuration, subMethod: controls?.inputs?.danger.id, })?.result && !isUndNullEmp({ data: configuration?.danger, subMethod: controls?.inputs?.danger.id, })?.result ?
                                                        configuration?.danger : 0}
                                                    placeholder={labels?.danger[modalObj?.languageObj?.id]}
                                                    title={labels?.danger[modalObj?.languageObj?.id]}
                                                    type='number' />
                                            </div>
                                            <div className='form-text' style={styles?.inputMsgAlert}>{parse(errors?.danger)}</div>
                                        </div>
                                    </div>
                                </div>

                                <div className='row'>
                                    <div className='col-md-12 mb-0'>
                                        <div className='form-group d-flex align-items-center'>
                                            <label className='d-flex align-items-center'
                                                htmlFor={controls?.checkBox?.isValid.id}
                                                style={{ cursor: (process?.save || modalObj?.type === 2) ? 'default' : 'pointer' }}>
                                                <div className='mr-3'>
                                                    <input id={controls?.checkBox?.isValid.id}
                                                        type='checkbox'
                                                        disabled={process?.save}
                                                        style={{ cursor: (process?.save || modalObj?.type === 2) ? 'default' : 'pointer' }}
                                                        data-toggle='toggle'
                                                        data-size='xs'
                                                        data-width={50}
                                                        data-onstyle='primary'
                                                        data-on={labels?.yes?.[modalObj?.languageObj?.id]}
                                                        data-off={labels?.no?.[modalObj?.languageObj?.id]}
                                                        onClick={(e) => setConfiguration(prev => ({ ...prev, isValid: e?.target?.checked, }))}
                                                        onChange={(e) => setConfiguration(prev => ({ ...prev, isValid: e?.target?.checked, }))} />
                                                </div>
                                                <small className='text-muted text-uppercase font-weight-bold' co={controls?.checkBox?.isValid.id}>
                                                    {labels?.isActive?.[modalObj?.languageObj?.id]}
                                                </small>
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ) : (
                            <div className='row'>
                                {[
                                    { label: labels?.name?.[modalObj?.languageObj?.id], value: configuration?.name || '---', icon: icons?.fasFa?.spellCheck, color: 'primary' },
                                    { label: `${labels?.date?.[modalObj?.languageObj?.id]} (${labels?.from?.[modalObj?.languageObj?.id]})`, value: setDateTimeFormatGlobalString({ date: configuration?.fromDateTime, dateFormat: modalObj?.languageObj?.format?.date?.f1, timeFormat: modalObj?.languageObj?.format?.time?.type, withSeconds: false })?.result || '---', icon: icons?.faFa?.calendarAlt, color: 'info' },
                                    { label: `${labels?.date?.[modalObj?.languageObj?.id]} (${labels?.to?.[modalObj?.languageObj?.id]})`, value: setDateTimeFormatGlobalString({ date: configuration?.toDateTime, dateFormat: modalObj?.languageObj?.format?.date?.f1, timeFormat: modalObj?.languageObj?.format?.time?.type, withSeconds: false })?.result || '---', icon: icons?.faFa?.calendarAlt, color: 'info' },
                                    { label: labels?.paginated[modalObj?.languageObj?.id], value: configuration?.paginated || 0, icon: icons?.sortNumericUpAlt, color: 'primary' },
                                    { label: labels?.success[modalObj?.languageObj?.id], value: configuration?.success || 0, icon: icons?.fasFa?.checkCircle, color: 'success' },
                                    { label: labels?.warning[modalObj?.languageObj?.id], value: configuration?.warning || 0, icon: icons?.fasFa?.exclamationTrinagle, color: 'warning text-dark' },
                                    { label: labels?.danger[modalObj?.languageObj?.id], value: configuration?.danger || 0, icon: icons?.fasFa?.times, color: 'danger' },
                                    { label: labels?.isActive?.[modalObj?.languageObj?.id], value: configuration?.isValid ? labels?.yes?.[modalObj?.languageObj?.id] : labels?.no?.[modalObj?.languageObj?.id], icon: icons?.fasFa?.toggleOn, color: configuration?.isValid ? 'primary' : 'secondary', wide: true },
                                ].map((field, idx) => (
                                    <div key={idx} className={`col-12 col-md-${field.wide ? '12' : '6'} mb-3`}>
                                        <div className={`p-3 rounded bg-light border-left border-${field.color || 'primary'} shadow-sm h-100`}
                                            style={{ borderLeftWidth: '5px' }}>
                                            <small className='text-muted text-uppercase font-weight-bold d-block mb-1'
                                                style={settings?.html?.labels?.detailMicro}>
                                                {field.icon && <i className={`${field.icon} mr-1`} />} {field.label}
                                            </small>
                                            <span className='text-dark font-weight-bold'>{field.value}</span>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>
                </form>
            </Modal.Body>
            <Modal.Footer className='border-top-0 pb-4 px-4 bg-white'>
                <div className='d-flex justify-content-center w-100'>
                    <button id={controls?.buttons?.save?.id}
                        className={controls?.buttons?.save?.defaultClass}
                        style={{ borderRadius: '5px' }}
                        disabled={process?.save}
                        hidden={modalObj?.type === 2}
                        type='button'
                        onClick={(e) => modalObj?.type === 0 ? addConfiguration({ e, subMethod: controls?.buttons?.save?.id }) : editConfiguration({ e, subMethod: controls?.buttons?.save?.id })}>
                        {process?.save ? (
                            <span className={settings?.react?.html?.spinner?.borderSm}
                                role='status' aria-hidden='true'></span>
                        ) : (
                            <i id={controls?.icons?.save?.id}
                                className={controls?.icons?.save?.defaultClass} />
                        )} {labels?.save?.[modalObj?.languageObj?.id]}
                    </button>
                    <button id={controls?.buttons?.back?.id}
                        className={controls?.buttons?.back?.defaultClass}
                        style={{ borderRadius: '5px' }}
                        disabled={process?.save}
                        type='button'
                        onClick={() => setDefaultValue({ closeModal: true, subMethod: controls?.buttons?.back?.id })}>
                        <i id={controls?.icons?.back?.id}
                            className={controls?.icons?.back?.defaultClass} /> {labels?.back?.[modalObj?.languageObj?.id]}
                    </button>
                </div>
            </Modal.Footer>
        </Modal>
    )
}